module.exports = __webpack_public_path__ + "ba95810b56f476990ca71d15139d5111.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-Medium.ttf
// module id = 1250
// module chunks = 0